// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7b-4";
export var collapsed = "_7b-1";
export var headerBar = "_7b-0";
export var leftHeaderContent = "_7b-3";
export var subjectContainer = "_7b-2";